exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-industry-template-jsx": () => import("./../../../src/templates/IndustryTemplate.jsx" /* webpackChunkName: "component---src-templates-industry-template-jsx" */),
  "component---src-templates-service-template-jsx": () => import("./../../../src/templates/ServiceTemplate.jsx" /* webpackChunkName: "component---src-templates-service-template-jsx" */)
}

